import { useImageViewer } from "./ImageViewerProvider";

export const ImageExpandButton = ({ label, className = "", testId, children, ...props }) => (
        <button
            type="button"
            className={`image-trigger ${className}`}
            aria-label={`Ingrandisci: ${label}`}
            aria-haspopup="dialog"
            data-testid={testId}
            data-cursor="zoom"
            {...props}
        >
            {children}
            <span className="image-trigger-mark" aria-hidden="true"><span /></span>
        </button>
);

export const ImageTrigger = ({ images, index = 0, children, ...props }) => {
    const open = useImageViewer();
    const image = images[index];
    if (!image) return children;
    return (
        <ImageExpandButton label={image.alt || image.title} {...props}
            onClick={(event) => open(images, index, event.currentTarget)}>
            {children}
        </ImageExpandButton>
    );
};